$(document).ready(function () {
  // Add on Pre Drape saree Checkbox function
  $("input[name=addonPreDrapeThisSaree]").click((ev) => {
    if (ev.target.checked) {
      var data_var = $(ev.target).attr("data-varid");
      $(".custom-sareeaddon")
        .find(".custom_adddtocart")
        .addClass("customm__addonproduct");
      var mainProduct_handle = $(".custom__varid").attr("data-handle");
      $(".custom-sareeaddon").append(
        '<select class="size-selector" name="properties[Size]">' +
          '<option value="XS-S">XS-S</option>' +
          '<option value="M-L">M-L</option>' +
          '<option value="XL-XXL">XL-XXL</option>' +
          "</select>"
      );

      $(".custom-sareeaddon").append(
        ' <input  type="hidden" class="addonpdptitle" name="properties[_addonproduct]" value="main_product">'
      );
      $(".custom-sareeaddon").append(
        '<input type="hidden" class="product__hanle" name="properties[main__product]" value="' +
          mainProduct_handle +
          '">'
      );

      $("#predrapeSection").show();
      // $("#PreDrapeWaist").removeClass("Alert--error");
      // $("#PreDrapeLength").removeClass("Alert--error");
      // $("#PreDrapeHip").removeClass("Alert--error");
    } else {
      $("#predrapeSection").hide();
      $("#PreDrapeSize").val("");
      $(".custom-sareeaddon").find("input.addonpdptitle").remove();
      $(".custom-sareeaddon").find("input.product__hanle").remove();
      $(".custom-sareeaddon")
        .find(".custom_adddtocart")
        .removeClass("customm__addonproduct");
    }
  });

  // Event listener for the Add to Cart button
  const addToCartButton = document.querySelector(
    'button[name="add"][class*="add-to-cart"]'
  );
  const BuyitNowButton = document.querySelector(
    'button[class*="shopify-payment-button__button"]'
  );
  const giftWrapCheckbox = document.querySelector(".addon-product-checkbox");
  const title = document.getElementById("wear_guide_product_title")
    ? document.getElementById("wear_guide_product_title").textContent
    : "";
  // Declare a global variable
  let quantityValue = "";

  // Select the input field
  const quantityInput = document.querySelector(".js-qty__num");

  // Variable to store the current value
  let currentValue = quantityInput.value;

  // Listen for input changes
  quantityInput.addEventListener("input", () => {
    currentValue = quantityInput.value; // Update the variable with the new value
  });

  // Function to handle input change
  function handleInputChange(event) {
    quantityValue = event.target.value; // Update the global variable
    // Log or use the variable
  }

  // Attach the event listener to the input field
  quantityInput.addEventListener("input", handleInputChange);
  // Attach event listeners to buttons

  const preDrapeSizeSelect = document.querySelector("#PreDrapeSize");
  const addonCheckbox = document.querySelector(".addon-product-checkbox");

  function toggleButtons() {
    console.log("adas");
    const isCheckboxChecked = addonCheckbox.checked;
    const isSizeSelected = preDrapeSizeSelect?.value !== "";
    if (isCheckboxChecked && !isSizeSelected) {
      // Disable buttons if checkbox is checked and size is not selected
      addToCartButton.disabled = true;
    } else {
      // Enable buttons if either checkbox is unchecked or size is selected
      addToCartButton.disabled = false;
    }
  }

  addonCheckbox?.addEventListener("change", toggleButtons);
  preDrapeSizeSelect?.addEventListener("change", toggleButtons);

  toggleButtons();

  addToCartButton.addEventListener("click", () => {
    const quantityInput = document.querySelector(".js-qty__num");

    // Variable to store the current value
    let currentValue = quantityInput.value;
    const selectElement = document.getElementById("PreDrapeSize");
    const formAttributeValue = selectElement.getAttribute("form");
    const formElement = document.getElementById(formAttributeValue);
    const element = document.querySelector(".wear-guid-qty"); // Get the element
    const dataAttributeValue = element.getAttribute("data-attribute"); // Get the value of the data-attribute

    // call quantity function
    if (giftWrapCheckbox && giftWrapCheckbox.checked) {
      // Wait for the product to be added to the cart
      formElement.addEventListener("submit", (event) => {
        event.preventDefault(); // Prevent default submission
        setTimeout(() => {
          // Fetch the cart
          fetch("/cart.js")
            .then((response) => response.json())
            .then((cart) => {
              // Prepare the form data for adding the fee
              const formData = new FormData();
              formData.append("id", 45798137102388); // ID of the product or fee you want to add
              if (currentValue <= dataAttributeValue) {
                formData.append("quantity", currentValue);
              } else {
                formData.append("quantity", 1);
              }
              formData.append(
                "properties[Pre Drape for]",
                `Pre Drape for ${title} (Size - ${$("#PreDrapeSize").val()})`
              );
              if (!$("#PreDrapeSize").val()) {
                alert("Please select a size before adding to the cart.");
                return; // Stop execution if no size is selected
              }

              // Send the POST request with form data
              fetch("/cart/add.js", {
                method: "POST",
                body: formData,
              })
                .then((response) => {
                  if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                  }
                  if (response.ok) {
                    window.location.href = "/cart";
                  }
                  return response.json();
                })
                .then((data) => console.log("Additional fee added:", data))
                .catch((error) =>
                  console.error("Error adding additional fee:", error)
                );
            });
        }, 1000);
      });
      // Wait 500ms to ensure the cart is updated
    } else {
      formElement.addEventListener(
        "submit",
        (event) => {
          event.preventDefault(); // Prevent default submission
          setTimeout(() => {
            window.location.href = "/cart";
          },1500);
        });
      console.log("Gift wrap not selected. No additional fee added.");
      $("#PreDrapeSize").val("");
    }
  });

  BuyitNowButton.addEventListener("click", () => {
    const element = document.querySelector(".wear-guid-qty"); // Get the element
    const dataAttributeValue = element.getAttribute("data-attribute");

    var variantId = document
      .getElementById("whatmoreVariantId")
      .getAttribute("data-wh");

    const quantityInput = document.querySelector(".js-qty__num");

    // Variable to store the current value
    let currentValue = quantityInput.value;

    // Check if gift wrap is selected
    if (giftWrapCheckbox && giftWrapCheckbox.checked) {
      // First, add the fixed product with ID 45798137102388
      const addToCartProduct = (productId, quantity, properties) => {
        const formData = new FormData();
        formData.append("id", productId);
        if (quantity <= dataAttributeValue) {
          formData.append("quantity", quantity);
        } else {
          formData.append("quantity", 1);
        }
        if (properties) {
          formData.append(
            "properties[Pre Drape for]",
            `Pre Drape for ${title} (Size - ${$("#PreDrapeSize").val()})`
          );
        }

        return fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        }).then((response) => {
          if (!response.ok) {
            throw new Error(
              `Error adding product with ID ${productId}: ${response.status}`
            );
          }
          return response.json();
        });
      };

      // Add the fixed product first (ID: 45798137102388)
      addToCartProduct(
        45798137102388,
        currentValue,
        `Pre Drape for ${title} (Size - ${$("#PreDrapeSize").val()})`
      )
        .then(() => {
          // Then, add the product with the dynamic variantId
          return addToCartProduct(
            variantId,
            currentValue,
            `Pre Drape for ${title} (Size - ${$("#PreDrapeSize").val()})`
          );
        })
        .then(() => {
          console.log("Both products added to the cart");
          // Redirect to checkout
          window.location.href = "/checkout";
        })
        .catch((error) => {
          console.error("Error adding products:", error);
        });
    } else {
      console.log("Gift wrap not selected. No additional fee added.");
      $("#PreDrapeSize").val("");
    }
  });
});
